// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__53Los","logo":"Home_logo__s21Dj","btnSection":"Home_btnSection__t10eT","imageInput":"Home_imageInput__+syzk","error":"Home_error__szGrz"};